import { render, staticRenderFns } from "./ChooseColor.vue?vue&type=template&id=004d97ce"
import script from "./ChooseColor.vue?vue&type=script&lang=js"
export * from "./ChooseColor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports